import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import { useEffect, useState } from 'react';
import s from './styles.module.css';

// Фикс для отображения стандартных маркеров Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

const MapComponent = ({ latitude, longitude, setLatitude, setLongitude, mapError, setMapError }) => {
    const [position, setPosition] = useState({
        lat: latitude || 42.8746,
        lng: longitude || 74.6122,
    });

    const [popupOpen, setPopupOpen] = useState(true);

    useEffect(() => {
        if (latitude && longitude) {
            setPosition({ lat: latitude, lng: longitude });
            setPopupOpen(true);
        }
    }, [latitude, longitude]);

    const LocationMarker = () => {
        const map = useMapEvents({
            click(e) {
                setPosition(e.latlng);
                setLatitude(e.latlng.lat);
                setLongitude(e.latlng.lng);
                setPopupOpen(true);
                setMapError('');
                map.flyTo(e.latlng, map.getZoom());
            },
        });

        return (
            <Marker position={position}>
                {popupOpen && <Popup onClose={() => setPopupOpen(false)}>Вы выбрали это место!</Popup>}
            </Marker>
        );
    };

    return (
        <div className={s.mapComponents}>
            <MapContainer center={position} zoom={13} style={{ height: '420px', width: '100%' }}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <LocationMarker />
            </MapContainer>
            {mapError && <p className={s.errorText}>{mapError}</p>}
        </div>
    );
};

export default MapComponent;
